import React from "react";

const tools = [
  "Adobe",
  "CapCut",
  "Canva",
  "Figma",
  "ElevenLabs",
  "Facebook Ad Library",
  "ChatGPT",
  "System.IO",
];

function Toolstack() {
  // Duplicate tools to create a smooth continuous loop
  const scrollTools = [...tools, ...tools, ...tools, ...tools];

  return (
    <div className="w-full overflow-hidden py-10 bg-accent-black border-y border-white/5 relative">
      {/* Gradient overlays for smooth fading edges */}
      <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-accent-black to-transparent z-10 pointer-events-none"></div>
      <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-accent-black to-transparent z-10 pointer-events-none"></div>

      <div className="service-container flex items-center">
        <div className="service-track flex items-center gap-12 whitespace-nowrap">
          {scrollTools.map((tool, index) => (
            <div
              key={index}
              className="flex items-center gap-12"
            >
              <span className="text-3xl md:text-5xl font-black tracking-tighter text-transparent bg-clip-text bg-gradient-to-r from-zinc-600 to-zinc-400 opacity-60 hover:opacity-100 hover:from-white hover:to-white transition-all duration-300 cursor-default uppercase">
                {tool}
              </span>
              <span className="text-brand text-2xl font-bold">•</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Toolstack;
